export default __webpack_public_path__ + "static/media/facebook-icon.172a6906.svg";